import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-performance-reports',
	templateUrl: './performance-reports.component.html',
	styleUrls: ['./performance-reports.component.scss']
})
export class PerformanceReportsComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}
}



// WEBPACK FOOTER //
// ./src/app/routes/performance/performance-reports/performance-reports.component.ts